module.exports = __webpack_public_path__ + "img/Slack.0782072f.svg";